import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const InvitedSignUp = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "invited-sign-up" */ './hocs')),
});
